/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type MoveMultipleSkillsToCategoryModal_company = {
    readonly id: string;
    readonly skillCategories: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "MoveMultipleSkillsToCategoryModal_company";
};
export type MoveMultipleSkillsToCategoryModal_company$data = MoveMultipleSkillsToCategoryModal_company;
export type MoveMultipleSkillsToCategoryModal_company$key = {
    readonly " $data"?: MoveMultipleSkillsToCategoryModal_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"MoveMultipleSkillsToCategoryModal_company">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "skillCategories"
        ]
      }
    ]
  },
  "name": "MoveMultipleSkillsToCategoryModal_company",
  "selections": [
    (v0/*: any*/),
    {
      "alias": "skillCategories",
      "args": null,
      "concreteType": "SkillCategoryTypeConnection",
      "kind": "LinkedField",
      "name": "__Company_skillCategories_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillCategoryTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillCategory",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company"
};
})();
(node as any).hash = '17a0f6d4677d77fd9215a75fe64e8c3a';
export default node;
